import { Int } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';

/**
 * What an upsert actually did. A booking whose person already is a member of the same groups for an
 * overlapping runtime is skipped instead of aborting the whole batch, so the caller needs to know
 * how many of its bookings never made it into the database.
 */
@Entity()
export class BookingUpsertResult extends AdornisEntity {
  static override _class = 'BookingUpsertResult';

  constructor(doc: PartialEntityData<BookingUpsertResult>) {
    super(doc);
  }

  @Field(() => Int)
  upserted!: number;

  @Field(() => Int)
  skippedExisting!: number;
}
